import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody } from "../../../../components/card/card";
import Maintenance from "./maintenance";
import Rehabilitation from "./rehabilitation";
import Replacement from "./replacement";
function MachineList() {
  return (
    <div>
      <Maintenance />
    </div>
  );
}

export default MachineList;
